import {
  CriterionFreeText,
  EvidenceCardConfig,
} from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import { MedicalQuestion } from "../../../data-model/medicalQuestion";

interface SubjectiveQuestionProps {
  question: MedicalQuestion;
  stepNumber: number | string;
  textValue: string;
  onTextChange: (value: string) => void;
  evidenceCards?: EvidenceCardConfig[];
  children?: React.ReactNode;
}

const SubjectiveQuestion = (props: SubjectiveQuestionProps) => {
  const { question, stepNumber, textValue, onTextChange, evidenceCards } =
    props;

  return (
    <CriterionFreeText
      key={question.id}
      id={question.id}
      stepNumber={stepNumber}
      title={question.question}
      textareaName={question.id}
      textareaValue={textValue}
      onTextChange={onTextChange}
      textareaPlaceholder="Enter your response..."
      evidenceCards={evidenceCards}
      collapsible
      defaultExpanded
    >
      {props.children}
    </CriterionFreeText>
  );
};

export default SubjectiveQuestion;
